export enum MedicalJournalType {
    MedicalCheckups = 1,
    RejectedDrivers = 2,
}
